<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="
      cn(
        'flex min-h-[70px] shrink-0 items-center justify-between border-b border-default bg-white px-5 py-4',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
